import TeacherProfileDashboard from '@/views/teacher/TeacherDashboard/DivWrapperScreen/DivWrapperScreen.vue'
import CreateCourse from '@/views/teacher/CreateCourse.vue'
import CourseModules from '@/views/teacher/CourseModules.vue'
import TeacherAnalytics from '@/views/teacher/TeacherAnalytics.vue'
import TeacherScreen8 from '@/components/TeacherScreen8.vue'
import { screen8Data } from '@/data.js'
import { STAFF_ROLES } from '../routeRoles'

export const teacherRoutes = [
	{
		path: '/teacher',
		redirect: '/teacher/dashboard',
	},
	{
		path: '/teacher/dashboard',
		name: 'TeacherProfile',
		component: TeacherProfileDashboard,
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Панель преподавателя',
		},
	},
	{
		path: '/teacher/homework/:homeworkId/review',
		name: 'TeacherHomeworkReview',
		component: () => import('@/views/teacher/HomeworkReview.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Проверка домашних заданий',
		},
	},
	{
		path: '/teacher/tests/:testId/review',
		name: 'TeacherTestReview',
		component: () => import('@/views/teacher/TestReview.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Проверка тестов',
		},
	},
	{
		path: '/teacher/profile',
		name: 'TeacherProfilePage',
		component: () => import('@/views/teacher/TeacherProfile.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Профиль преподавателя',
		},
	},
	{
		path: '/teacher/settings',
		name: 'TeacherSettingsPage',
		component: () => import('@/views/teacher/TeacherSettings.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Настройки преподавателя',
		},
	},
	{
		path: '/teacher/courses/create',
		name: 'CreateCourseOld',
		component: CreateCourse,
		props: { routeMode: 'create', routeCourseId: null },
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Создание курса',
		},
	},
	{
		path: '/teacher/courses/:id/content',
		name: 'CourseContent',
		component: CreateCourse,
		props: route => ({ routeMode: 'content', routeCourseId: route.params.id || null }),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Управление курсом',
		},
	},
	{
		path: '/teacher/courses/:id/edit',
		name: 'CourseEdit',
		component: CreateCourse,
		props: route => ({ routeMode: 'edit', routeCourseId: route.params.id || null }),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Редактирование курса',
		},
	},
	{
		path: '/teacher/courses/:id/modules',
		name: 'CourseModules',
		component: CourseModules,
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Управление модулями',
		},
	},
	{
		path: '/teacher/courses/:id/map',
		name: 'TeacherCourseMap',
		component: () => import('@/views/teacher/TeacherCourseMap.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Карта курса',
		},
	},
	{
		path: '/teacher/courses/:id',
		name: 'TeacherCoursePage',
		component: () => import('@/views/teacher/TeacherCoursePage.vue'),
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Страница курса преподавателя',
		},
	},
	{
		path: '/teacher/analytics',
		name: 'TeacherAnalytics',
		component: TeacherAnalytics,
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Аналитика',
		},
	},
	{
		path: '/teacher/screen8-preview',
		name: 'TeacherScreen8Preview',
		component: TeacherScreen8,
		props: screen8Data,
		meta: {
			requiresAuth: true,
			roles: STAFF_ROLES,
			title: 'Предпросмотр модуля',
		},
	},
]
